import React from "react";
import history from "../../history";
import Config from "../../utils/config";
import {
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import CartTitle from "../CartTitle";
import CustomButton from "../CustomButton";
import Loader from "../Loader";
import DesignCard from "../DesignCard";
import InputText from "../InputText";

import get from "lodash/get";

const _ = { get };

class BranchDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleRejectModal: false,
      rejectionReason: "",
      selectedId: "",
    };
  }

  componentDidMount() {
    this.props.handleFetchSingleBranch(this.props.selectedId);
    let newState = this.state;
    newState.selectedId = this.props.selectedId;
    this.setState({ ...newState });
  }

  handleNameChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleToCreateTestimonial = () => {
    if (this.state.selectedId) {
      history.push(
        `/branch/create-testimonial?branchId=${this.state.selectedId}`
      );
    } else {
      history.push(`/branch/list`);
    }
  };

  handleToUpdateForm = () => {
    if (this.state.selectedId !== "") {
      this.props.handleUpdateButtonClickPlace("branch");
      history.push(
        `/branch/update-branch?branchId=${this.state.selectedId}&status=${
          this.props.status
        }&page=${this.props.page - 1}&countryCode=${
          this.props.countryCode
        }&country=${this.props.country}&state=${this.props.state}&city=${
          this.props.city
        }&count=${this.props.count}&dealerEmail=${
          this.props.dealerEmail
        }&dealerPhone=${this.props.dealerPhone}&dealerId=${this.props.dealerId}`
      );
    } else {
      history.push(`/branch/list`);
    }
  };

  handleToBack = () => {
    let queryParams = this.props.query;
    if (queryParams === "") {
      this.props.handleToggleModel();
    } else {
      history.push(`/branch/list`);
    }
  };

  handleApproveBranch = () => {
    let data = {
      status: "APPROVED",
      branchId: this.props.branchData._id,
      rejectionReason: "",
    };

    let reqObj = {
      page: this.props.page,
      countryCode: this.props.countryCode,
      state: this.props.state,
      city: this.props.city,
      emailId: this.props.dealerEmail,
      phone: this.props.dealerPhone,
      branchId: this.props.dealerId,
      status: this.props.status,
      limit: this.props.count,
    };
    this.props.handleModerationStatus(data, reqObj);
  };

  handleDisapproveModelToggle = () => {
    let state = this.state;
    state.toggleRejectModal = !state.toggleRejectModal;
    this.setState({ ...state });
  };

  handleDisApproveBranch = () => {
    let state = this.state;
    let data = {
      status: "REJECTED",
      branchId: this.props.branchData._id,
      rejectionReason: state.rejectionReason,
    };

    let reqObj = {
      page: this.props.page,
      countryCode: this.props.countryCode,
      state: this.props.state,
      city: this.props.city,
      emailId: this.props.dealerEmail,
      phone: this.props.dealerPhone,
      branchId: this.props.dealerId,
      status: this.props.status,
      limit: this.props.count,
    };
    this.props.handleModerationStatus(data, reqObj);
    this.handleDisapproveModelToggle();
  };

  render() {
    let { elements } = this.props;

    return (
      <React.Fragment>
        {this.props.branchSingleDataStatus !== false ? <Loader /> : null}
        {this.props.moderationStatus !== false ? <Loader /> : null}

        <div className="hideSearch">
          <Row>
            <Col sm={12}>
              <CartTitle
                title={`${
                  this.props.branchData
                    ? this.props.branchData.branchName
                    : "Branch Detail"
                }`}
                Name={"Search"}
                customClass={"hidebtn"}
                innerTextClass={"hidetext"}
                iconClass={"hideexcel"}
              />
            </Col>
          </Row>
          <Card className="mb-3">
            <CardBody>
              {this.props.branchData ? (
                <React.Fragment>
                  <Row>
                    <Col md="12">
                      <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                        <span>
                          {_.get(
                            elements,
                            "branchDetailElements.subHeadingPersonalInformationElement",
                            "PERSONAL INFORMATION"
                          )}
                        </span>
                      </h2>
                    </Col>
                    <Col xl={12}>
                      <Row>
                        <Col xl={3} lg={3} md={12} sm={12} className="mb-2">
                          <div className="uploadedImgSize">
                            <img
                              src={`${Config.imageBaseUrl}/${this.props.branchData.primary_image}`}
                              alt="img"
                            />
                          </div>
                        </Col>

                        <Col xl={9} lg={9} md={12} sm={12} className="mb-2">
                          <Row>
                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.clubCoordinatorNameLabel",
                                  "Club Coordinator Name"
                                )}
                                titleName={
                                  this.props.branchData.storeManagerName
                                }
                              />
                            </Col>
                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.emailLabel",
                                  "Email"
                                )}
                                titleName={this.props.branchData.emailId}
                              />
                            </Col>
                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.phoneNumberLabel",
                                  "Phone Number"
                                )}
                                titleName={this.props.branchData.phone}
                              />
                            </Col>
                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.alternatePhoneNumberLabel",
                                  "Alternate Phone Number"
                                )}
                                titleName={this.props.branchData.altPhone}
                              />
                            </Col>

                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.countryLabel",
                                  "Country"
                                )}
                                titleName={this.props.branchData.country}
                              />
                            </Col>
                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.stateLabel",
                                  "State"
                                )}
                                titleName={this.props.branchData.state}
                              />
                            </Col>
                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.cityLabel",
                                  "City"
                                )}
                                titleName={this.props.branchData.city}
                              />
                            </Col>
                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.landmarkLabel",
                                  "Landmark"
                                )}
                                titleName={this.props.branchData.landmark}
                              />
                            </Col>

                            <Col md={4} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "branchDetailElements.pinCodeLabel",
                                  "Pincode"
                                )}
                                titleName={this.props.branchData.pincode}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={3} className="mb-4">
                      <DesignCard
                        cardClass={"textarea"}
                        name={_.get(
                          elements,
                          "branchDetailElements.addressLineOneLabel",
                          "Address Line 1"
                        )}
                        titleName={this.props.branchData.addressLine1}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        cardClass={"textarea"}
                        name={_.get(
                          elements,
                          "branchDetailElements.addressLineTwoLabel",
                          "Address Line 2"
                        )}
                        titleName={this.props.branchData.addressLine2}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        cardClass={"textarea"}
                        name={_.get(
                          elements,
                          "branchDetailElements.addressLineThreeLabel",
                          "Address Line 3"
                        )}
                        titleName={this.props.branchData.addressLine3}
                      />
                    </Col>

                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.latitudeLabel",
                          "Latitude"
                        )}
                        titleName={this.props.branchData.latitude}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.longitudeLabel",
                          "Longitude"
                        )}
                        titleName={this.props.branchData.longitude}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.branchStatusLabel",
                          "Branch Status"
                        )}
                        titleName={this.props.branchData.branchStatus}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.branchStatusLabel",
                          "Moderation Status"
                        )}
                        titleName={this.props.branchData.moderationStatus}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <h2 className="title-bar secondary-title f-weight-bold themeColor my-3 pb-2">
                        <span>
                          {" "}
                          {_.get(
                            elements,
                            "branchDetailElements.subHeadingMainInformationElement",
                            "MAIN INFORMATION"
                          )}
                        </span>
                      </h2>
                    </Col>

                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.dealerNameLabel",
                          "Dealer Name"
                        )}
                        titleName={
                          this.props.branchData.dealer !== null
                            ? this.props.branchData.dealer.dealerName
                            : ""
                        }
                      />
                    </Col>

                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.dealerIdLabel",
                          "Dealer Id"
                        )}
                        titleName={
                          this.props.branchData.dealer !== null
                            ? this.props.branchData.dealer.dealerId
                            : ""
                        }
                      />
                    </Col>

                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.dealerStatusLabel",
                          "Dealer Status"
                        )}
                        titleName={
                          this.props.branchData.dealer !== null
                            ? this.props.branchData.dealer.dealerStatus
                            : ""
                        }
                      />
                    </Col>

                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.branchCodeLabel",
                          "Branch Code"
                        )}
                        titleName={this.props.branchData.branchCode}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.dealerWebUrlLabel",
                          "Dealer's Website URL"
                        )}
                        titleName={this.props.branchData.websiteUrl}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.weeklyOffLabel",
                          "Weekly Off"
                        )}
                        titleName={this.props.branchData.weeklyOff}
                      />
                    </Col>

                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.businessHourLabel",
                          "Business Hours"
                        )}
                        titleName={this.props.branchData.businessHours}
                      />
                    </Col>
                    <Col md={3} className="mb-4">
                      <DesignCard
                        name={_.get(
                          elements,
                          "branchDetailElements.descriptionLabel",
                          "Description"
                        )}
                        titleName={this.props.branchData.branchDescription}
                      />
                    </Col>
                    {this.props.branchData.moderationStatus === "APPROVED" ? (
                      <React.Fragment>
                        <Col md="12">
                          <h2 className="title-bar secondary-title f-weight-bold themeColor my-3 pb-2">
                            <span>
                              {_.get(
                                elements,
                                "branchDetailElements.subHeadingTestimonialsElement",
                                "TESTIMONIALS"
                              )}
                            </span>
                          </h2>
                        </Col>
                        {this.props.branchData.testimonials.map(
                          (item, index) => (
                            <Col key={index} sm={3} className="mb-3">
                              <Card>
                                <CardBody>
                                  <div className="card-block">
                                    <figure className="profile">
                                      <img
                                        src={`${Config.imageBaseUrl}${item.image}`}
                                        className=""
                                        alt=""
                                      />
                                    </figure>
                                    <div className="title mb-0 mt-0 d-flex justify-content-between align-items-center">
                                      <span>
                                        {_.get(
                                          elements,
                                          "branchDetailElements.dynamicTitleLabel",
                                          "Title : "
                                        )}
                                        {item.title}
                                      </span>
                                    </div>
                                    <div className="title mb-0 mt-1 d-flex justify-content-between align-items-center">
                                      <span>
                                        {_.get(
                                          elements,
                                          "branchDetailElements.dynamicAuthorLabel",
                                          "Author : "
                                        )}
                                        {item.author}
                                      </span>
                                    </div>
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          )
                        )}
                      </React.Fragment>
                    ) : null}
                  </Row>

                  <Col md="12">
                    {this.props.branchData.moderationStatus === "PENDING" ? (
                      <div className="d-flex justify-content-center justify-content-lg-end  position-relative my-3 ">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.backButtonElement",
                            "Back"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleToBack(e)}
                        />

                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.updateButtonElement",
                            "Update"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleToUpdateForm(e)}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.disapproveButtonElement",
                            "Reject"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) =>
                            this.handleDisapproveModelToggle(e)
                          }
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.approveButtonElement",
                            "Approve"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleApproveBranch(e)}
                        />
                      </div>
                    ) : null}

                    {this.props.branchData.moderationStatus === "APPROVED" ? (
                      <div className="d-flex justify-content-center justify-content-lg-end  position-relative my-3 ">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.backButtonElement",
                            "Back"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleToBack(e)}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.addTestimonialButtonElement",
                            "Add Testimonial"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleToCreateTestimonial(e)}
                        />
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.updateButtonElement",
                            "Update"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleToUpdateForm(e)}
                        />
                      </div>
                    ) : null}

                    {this.props.branchData.moderationStatus === "REJECTED" ? (
                      <div className="d-flex justify-content-center justify-content-lg-end  position-relative my-3 ">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.backButtonElement",
                            "Back"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleToBack(e)}
                        />

                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchDetailElements.updateButtonElement",
                            "Update"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={(e) => this.handleToUpdateForm(e)}
                        />
                      </div>
                    ) : null}
                  </Col>
                </React.Fragment>
              ) : null}
            </CardBody>
          </Card>
          <Modal isOpen={this.state.toggleRejectModal}>
            <ModalHeader toggle={this.handleDisapproveModelToggle}>
              {_.get(
                elements,
                "memberShipDetailElements.rejectionModelLabel",
                "Rejection Reason"
              )}
            </ModalHeader>
            <ModalBody>
              <InputText
                inputType={"textarea"}
                inputName={"rejectionReason"}
                customValue={this.state.rejectionReason}
                customOnChange={(e) => this.handleNameChange(e)}
              />
            </ModalBody>
            <ModalFooter>
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "memberShipDetailElements.rejectModelButtonElement",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => this.handleDisApproveBranch(e)}
              />
            </ModalFooter>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

export default BranchDetailPage;
